export default __webpack_public_path__ + "static/media/svea_b.5c5bd9ae.svg";